enum ApplyPromoCodeFailureReason {
  InvalidPromoCode = 'InvalidPromoCode',
  MosConflict = 'MosConflict',
  PromoCartItemsConflict = 'PromoCartItemsConflict',
}

export default ApplyPromoCodeFailureReason;
